// DualListBox
export const handleChangeDualBox = that => (selected, position, handleUpdates = () => { }) => {
    const listIncluded = [...that.state[selected.target].included]
    const listExcluded = [...that.state[selected.target].excluded]

    if (position === 'included') {
        for (var i = listExcluded.length; i--;) {
            if (listExcluded[i].value === selected.value) listExcluded.splice(i, 1);
        }
        listIncluded.push(selected)
    } else {
        for (var x = 0; x < listIncluded.length; x++) {
            if (listIncluded[x].value === selected.value) listIncluded.splice(x, 1);
        }
        listExcluded.push(selected)
    }

    that.setState(prevState => ({
        [selected.target]: {
            ...prevState[selected.target],
            included: listIncluded,
            excluded: listExcluded
        }
    }), () => handleUpdates())
}

// DualListBox
export const moveAll = that => (target, direction) => {
    const listIncluded = [...that.state[target].included];
    const listExcluded = [...that.state[target].excluded];
    if (direction === 'toRight') {
        that.setState({
            [target]: {
                included: [],
                excluded: [...listExcluded, ...listIncluded]
            }
        })
    } else {
        that.setState({
            [target]: {
                included: [...listExcluded, ...listIncluded],
                excluded: []
            }
        })
    }
}
